(() => {
  function initialisePatternTool(tool) {
    if (!tool || tool.dataset.initialised === 'true') return;
    tool.dataset.initialised = 'true';

    const fileInput = tool.querySelector('[data-pattern-file]');
    const canvas = tool.querySelector('[data-pattern-canvas]');
    const tileSizeInput = tool.querySelector('[data-tile-size]');
    const spacingInput = tool.querySelector('[data-tile-spacing]');
    const repeatInput = tool.querySelector('[data-repeat-style]');
    const backgroundInput = tool.querySelector('[data-background-colour]');
    const downloadButton = tool.querySelector('[data-download-pattern]');
    const resetButton = tool.querySelector('[data-reset-pattern]');
    const sizeOutput = tool.querySelector('[data-size-output]');
    const spacingOutput = tool.querySelector('[data-spacing-output]');
    const status = tool.querySelector('[data-pattern-status]');

    if (!fileInput || !canvas) return;

    const context = canvas.getContext('2d');
    let uploadedImage = null;

    canvas.width = 1200;
    canvas.height = 800;

    function showPlaceholder() {
      const background = backgroundInput?.value || '#f8f5f2';

      context.fillStyle = background;
      context.fillRect(0, 0, canvas.width, canvas.height);

      context.fillStyle = '#494149';
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.font = '600 30px sans-serif';
      context.fillText(
        'Your repeating pattern will appear here',
        canvas.width / 2,
        canvas.height / 2
      );
    }

    function drawPattern() {
      if (!uploadedImage) {
        showPlaceholder();
        return;
      }

      const tileSize = Number(tileSizeInput.value);
      const spacing = Number(spacingInput.value);
      const repeatStyle = repeatInput.value;
      const step = tileSize + spacing;
      const background = backgroundInput.value;

      context.clearRect(0, 0, canvas.width, canvas.height);
      context.fillStyle = background;
      context.fillRect(0, 0, canvas.width, canvas.height);

      const scale = Math.min(
        tileSize / uploadedImage.naturalWidth,
        tileSize / uploadedImage.naturalHeight
      );

      const width = uploadedImage.naturalWidth * scale;
      const height = uploadedImage.naturalHeight * scale;

      for (let row = -1; row <= Math.ceil(canvas.height / step) + 1; row++) {
        for (
          let column = -1;
          column <= Math.ceil(canvas.width / step) + 1;
          column++
        ) {
          let x = column * step;
          let y = row * step;

          if (repeatStyle === 'brick' && Math.abs(row) % 2 === 1) {
            x += step / 2;
          }

          if (repeatStyle === 'half-drop' && Math.abs(column) % 2 === 1) {
            y += step / 2;
          }

          context.drawImage(
            uploadedImage,
            x + (tileSize - width) / 2,
            y + (tileSize - height) / 2,
            width,
            height
          );
        }
      }
    }

    fileInput.addEventListener('change', (event) => {
      const file = event.target.files?.[0];

      if (!file) return;

      if (!file.type.startsWith('image/')) {
        status.textContent = 'Please choose a PNG, JPG or WEBP image.';
        return;
      }

      const reader = new FileReader();

      reader.onload = () => {
        const image = new Image();

        image.onload = () => {
          uploadedImage = image;
          status.textContent =
            'Image added. Use the controls to adjust your repeat.';
          drawPattern();
        };

        image.onerror = () => {
          status.textContent =
            'That image could not be opened. Please try another file.';
        };

        image.src = reader.result;
      };

      reader.onerror = () => {
        status.textContent = 'The image could not be read. Please try again.';
      };

      reader.readAsDataURL(file);
    });

    tileSizeInput.addEventListener('input', () => {
      sizeOutput.textContent = `${tileSizeInput.value}px`;
      drawPattern();
    });

    spacingInput.addEventListener('input', () => {
      spacingOutput.textContent = `${spacingInput.value}px`;
      drawPattern();
    });

    repeatInput.addEventListener('change', drawPattern);
    backgroundInput.addEventListener('input', drawPattern);

    downloadButton.addEventListener('click', () => {
      if (!uploadedImage) {
        status.textContent = 'Please add an image before downloading.';
        return;
      }

      canvas.toBlob((blob) => {
        if (!blob) {
          status.textContent = 'The preview could not be downloaded.';
          return;
        }

        const link = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);

        link.href = objectUrl;
        link.download = 'pattern-preview.png';
        link.click();

        URL.revokeObjectURL(objectUrl);
        status.textContent = 'Your pattern preview has been downloaded.';
      }, 'image/png');
    });

    resetButton.addEventListener('click', () => {
      uploadedImage = null;
      fileInput.value = '';
      tileSizeInput.value = '180';
      spacingInput.value = '20';
      repeatInput.value = 'standard';
      backgroundInput.value = '#f8f5f2';
      sizeOutput.textContent = '180px';
      spacingOutput.textContent = '20px';
      status.textContent = 'Choose an image to begin.';
      showPlaceholder();
    });

    showPlaceholder();
  }

  function initialiseAllPatternTools(container = document) {
    container
      .querySelectorAll('[data-pattern-tool]')
      .forEach(initialisePatternTool);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialiseAllPatternTools();
    });
  } else {
    initialiseAllPatternTools();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseAllPatternTools(event.target);
  });
})();